import {
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_SUCCESS,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_FAILURE,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_SUCCESS,
  GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_FAILURE,
  INSTALLER_SEARCH_REQUEST,
  INSTALLER_SEARCH_SUCCESS,
  INSTALLER_SEARCH_FAILURE,
  ASSIGN_TOKENS_TO_INSTALLER_REQUEST,
  ASSIGN_TOKENS_TO_INSTALLER_SUCCESS,
  ASSIGN_TOKENS_TO_INSTALLER_FAILURE,
  ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST,
  ASSIGN_TOKENS_TO_DISTRIBUTOR_SUCCESS,
  ASSIGN_TOKENS_TO_DISTRIBUTOR_FAILURE,
  RESET_INSTALLER_SEARCH,
  GET_STORE_URL_REQUEST,
  GET_STORE_URL_SUCCESS,
  GET_STORE_URL_FAILURE,
  RESET_SNACKBAR,
} from "./constants";

const initialState = {
  generatorTokenDistributorList: { generatorTokens: [] },
  loading: false,
  loading_bulk: false,
  loading_subcontractor: false,
  loading_assign: false,
  message: "",
  messageType: "",
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_REQUEST:
      return { ...state, loading: true };
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_SUCCESS:
      return {
        ...state,
        generatorTokenDistributorList: action.generatorTokenDistributorList,
        loading: false,
      };
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_FAILURE:
      return {
        ...state,
        generatorTokenDistributorList: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading: false,
      };
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_REQUEST:
      return { ...state, loading_bulk: true };
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_SUCCESS:
      return {
        ...state,
        generatorTokenDistributorListBulk:
          action.generatorTokenDistributorListBulk,
        loading_bulk: false,
      };
    case GET_GENERATOR_TOKEN_DISTRIBUTOR_LIST_BULK_FAILURE:
      return {
        ...state,
        generatorTokenDistributorListBulk: {},
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading_bulk: false,
      };

    case INSTALLER_SEARCH_REQUEST:
      return { ...state, searchLoader: true };
    case INSTALLER_SEARCH_SUCCESS:
      return {
        ...state,
        installerSearch: action.installerSearch.data,
        message: action.installerSearch.message,
        messageType: "success",
        searchLoader: false,
      };
    case INSTALLER_SEARCH_FAILURE:
      return {
        ...state,
        installerSearch: [],
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        searchLoader: false,
      };
    case ASSIGN_TOKENS_TO_INSTALLER_REQUEST:
      return { ...state, loading_assign: true };
    case ASSIGN_TOKENS_TO_INSTALLER_SUCCESS:
      return {
        ...state,
        installerSearch: [],
        assignResult: action.assignResult,
        message: action.assignResult.message,
        messageType: "success",
        loading_assign: false,
      };
    case ASSIGN_TOKENS_TO_INSTALLER_FAILURE:
      return {
        ...state,
        installerSearch: [],
        assignResult: action.assignResult,
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading_assign: false,
      };
    case ASSIGN_TOKENS_TO_DISTRIBUTOR_REQUEST:
      return { ...state, loading_assign: true };
    case ASSIGN_TOKENS_TO_DISTRIBUTOR_SUCCESS:
      return {
        ...state,
        installerSearch: [],
        assignResult: action.assignResult,
        message: action.assignResult.message,
        messageType: "success",
        loading_assign: false,
      };
    case ASSIGN_TOKENS_TO_DISTRIBUTOR_FAILURE:
      return {
        ...state,
        installerSearch: [],
        assignResult: action.assignResult,
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading_assign: false,
      };
    case RESET_INSTALLER_SEARCH:
      return { ...state, installerSearch: [] };
          case GET_STORE_URL_REQUEST:
      return { ...state, loading_storeUrl: true };
    case GET_STORE_URL_SUCCESS:
      return {
        ...state,
        storeUrl: action.storeUrl,
        loading_storeUrl: false,
      };
    case GET_STORE_URL_FAILURE:
      return {
        ...state,
        storeUrl: null,
        message: action.error && action.error.message ? action.error.message : "Unable to process your request. Please try after some time!!!",
        messageType: "error",
        loading_storeUrl: false,
      };
    case RESET_SNACKBAR:
      return { ...state, messageType: "" };
    default:
      return state;
  }
}

export default reducer;
